import React, { useState } from 'react';
import loading from '../../assets/loading.svg';
import history from '../../history';
import URI from 'urijs';

// Unified LoadingScreen component
export const LoadingScreen = ({
  redirectOnAuth,
  handleOidcError,
  parseOidcTokens
}) => {
  const [imgError, setImgError] = useState(false);

  // Common style
  const style = {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white'
  };

  // OIDCMain logic
  if (redirectOnAuth) {
    const { login, isAuthenticated } = redirectOnAuth;
    const { accessToken, idToken } = redirectOnAuth;
    React.useEffect(() => {
      if (!isAuthenticated) {
        const parsedSearch = URI.parseQuery(window.location.search);
        login('/safetysecure', { login_hint: parsedSearch.login_hint });
      } else {
        history.replace(
          `/with-gp2token?accessToken=${accessToken}&idToken=${idToken}`
        );
      }
      // eslint-disable-next-line
    }, [isAuthenticated]);
  }

  // OIDCLoading logic
  if (parseOidcTokens) {
    const currentURL = window.location.search;
    const parsedURL = URI.parseQuery(currentURL);
    const { error, error_description, state } = parsedURL;
    const accessTokenObj = JSON.parse(localStorage.getItem('oidc.default'));
    const accessToken =
      accessTokenObj && accessTokenObj.tokens
        ? accessTokenObj.tokens.accessToken
        : null;
    const idToken =
      accessTokenObj && accessTokenObj.tokens
        ? accessTokenObj.tokens.idToken
        : null;

    if (state && accessToken && idToken) {
      history.replace(
        `/with-gp2token?accessToken=${accessToken}&idToken=${idToken}`
      );
    }

    if (
      error === 'access_denied' &&
      error_description &&
      error_description.includes('AADB2C90091')
    ) {
      console.warn('User cancelled the login process');
      history.replace('/');
    }
  }

  // OIDCError logic
  if (handleOidcError) {
    history.replace(`/`, '_self');
  }

  // Callback logic: remove image node on error
  const handleImgError = e => {
    setImgError(true);
  };

  return (
    <div style={style}>
      {!imgError && (
        <img src={loading} alt="loading" onError={handleImgError} />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/containers/LoadingScreen/LoadingScreen.jsx